/* ============================================================
   F9 BUNDLE GUARD  —  Xboost slide-cart rules for the Buy-2 bundle
   Loaded globally (layout/theme.liquid) so it works wherever the
   Xboost cart drawer can open. It ONLY touches bundle lines
   (identified by the line-item property we set at add-to-cart);
   every other product in the cart is left completely alone.

   What it does:
   1. Hides the qty +/- selector on all bundle + gift lines (fixed qty).
   2. Shows the trash/remove button on only the LEAD bundle line;
      pressing it removes the WHOLE bundle (both hoodies + mystery).
   3. Anti-abuse backstop: if qualifying hoodies drop below 2, the
      free Mystery Hoodie line is removed automatically.
   4. The "Buy 1" purchase (no offer property) behaves as a normal
      product — its qty + remove stay visible.

   Config (labels / mystery id) is read from the picker snippet via
   localStorage so nothing here is hardcoded except safe fallbacks.
   ============================================================ */
(function () {
  'use strict';

  var DEFAULTS = {
    offerLabel: 'Buy 2 Get 1 - Free Mystery Hoodie',
    giftLabel:  'Free Mystery Hoodie (Buy 2 Get 1)',
    bogoLabel:  'Buy 1, Get 1 50% Off',
    mysteryId:  51936262193473
  };

  function cfg() {
    var c = {};
    try { c = JSON.parse(localStorage.getItem('f9_bundle_guard') || '{}'); } catch (e) {}
    if (window.F9_BUNDLE_GUARD_CFG) c = window.F9_BUNDLE_GUARD_CFG;
    return {
      offerLabel: c.offerLabel || DEFAULTS.offerLabel,
      giftLabel:  c.giftLabel  || DEFAULTS.giftLabel,
      bogoLabel:  c.bogoLabel  || DEFAULTS.bogoLabel,
      mysteryId:  c.mysteryId  || DEFAULTS.mysteryId
    };
  }

  var ROOT_SEL = '#xboost-upsell-slide-cart-root';
  var LINE_SEL = '.xb_slide_cart_product_line';
  var busy = false;

  function txt(el) { return (el && el.textContent ? el.textContent : ''); }

  // classify a rendered cart line
  function lineKind(lineEl, C) {
    var t = txt(lineEl);
    if (t.indexOf(C.giftLabel) !== -1) return 'gift';
    if (t.indexOf(C.offerLabel) !== -1) return 'hoodie';
    if (C.bogoLabel && t.indexOf(C.bogoLabel) !== -1) return 'hoodie'; // Offer 1 (Buy 1 Get 1 50%) lines
    return 'normal';
  }

  /* ---------- DOM rules on the rendered drawer ---------- */
  function applyDom() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    var C = cfg();
    var lines = Array.prototype.slice.call(root.querySelectorAll(LINE_SEL));
    var leadAssigned = false;

    lines.forEach(function (line) {
      var kind = lineKind(line, C);
      if (kind === 'normal') {
        line.classList.remove('f9-cart-hide-qty', 'f9-cart-hide-delete');
        return;
      }
      // bundle or gift line -> fixed qty, no qty selector
      line.classList.add('f9-cart-hide-qty');

      // lead line (first bundle/gift line in DOM order) keeps the remove button
      if (!leadAssigned) {
        leadAssigned = true;
        line.classList.remove('f9-cart-hide-delete');
        var del = line.querySelector('.xb_slide_cart_product_button_delete');
        if (del && !del.__f9bound) {
          del.__f9bound = true;
          del.addEventListener('click', function (e) {
            // take over Xboost's single-line delete -> remove the whole bundle
            e.preventDefault();
            e.stopImmediatePropagation();
            removeBundleGroup();
          }, true);
        }
      } else {
        line.classList.add('f9-cart-hide-delete');
      }
    });
  }

  /* ---------- cart-data helpers (source of truth) ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  function propOf(item, key) {
    return item && item.properties && item.properties[key];
  }

  function updates(map) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: map })
    }).then(function (r) { return r.json(); });
  }

  function notifyCartChanged() {
    // nudge Xboost / theme to re-render the drawer
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
    var bubble = document.querySelector('cart-drawer, #CartDrawer');
    if (bubble && bubble.renderContents) { getCart().then(function () {}); }
  }

  // remove every line that belongs to the bundle group
  function removeBundleGroup() {
    if (busy) return; busy = true;
    getCart().then(function (cart) {
      var map = {};
      (cart.items || []).forEach(function (it) {
        if (propOf(it, '_f9_bundle')) map[it.key] = 0;
      });
      if (!Object.keys(map).length) { busy = false; return; }
      return updates(map).then(function () { notifyCartChanged(); });
    }).catch(function (e) { console.error('[f9-guard] removeBundleGroup', e); })
      .finally(function () { busy = false; setTimeout(applyDom, 300); });
  }

  // backstop: if hoodies < 2, strip the free mystery hoodie
  function antiAbuse() {
    if (busy) return;
    getCart().then(function (cart) {
      var hoodieQty = 0, giftKeys = [];
      (cart.items || []).forEach(function (it) {
        var tag = propOf(it, '_f9_bundle');
        if (tag === 'hoodie') hoodieQty += it.quantity;
        else if (tag === 'gift') giftKeys.push(it.key);
      });
      if (giftKeys.length && hoodieQty < 2) {
        busy = true;
        var map = {};
        giftKeys.forEach(function (k) { map[k] = 0; });
        updates(map).then(function () { notifyCartChanged(); })
          .catch(function (e) { console.error('[f9-guard] antiAbuse', e); })
          .finally(function () { busy = false; setTimeout(applyDom, 300); });
      }
    }).catch(function () {});
  }

  /* ---------- observe the drawer ---------- */
  var deb;
  function onMutate() {
    // PERF (no behavior change): skip while the cart drawer isn't in the DOM — e.g. the
    // whole page-load window and any time the cart is closed. Nothing to guard then, so this
    // avoids the debounced work + /cart.js check. When the drawer opens, that insertion is
    // itself a mutation and the root is already present when this fires, so guarding is unchanged.
    if (!document.querySelector(ROOT_SEL)) return;
    clearTimeout(deb);
    deb = setTimeout(function () { applyDom(); antiAbuse(); }, 120);
  }

  function boot() {
    applyDom();
    var mo = new MutationObserver(onMutate);
    mo.observe(document.body, { childList: true, subtree: true });
    // also react to our own add + generic cart events
    document.addEventListener('f9:bundle-added', function () { setTimeout(function () { applyDom(); antiAbuse(); }, 400); });
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { applyDom(); antiAbuse(); }, 200); });
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
